import request from '@/utils/request'

// 查询店铺续费申请记录列表
export function listRenewRecord(query) {
  return request({
    url: '/shop/renew/record/list',
    method: 'get',
    params: query,
  })
}

// 查询店铺续费申请记录分页
export function pageRenewRecord(query) {
  return request({
    url: '/shop/renew/record/page',
    method: 'get',
    params: query,
  })
}

// 查询店铺续费申请记录详细
export function getRenewRecord(data) {
  return request({
    url: '/shop/renew/record/detail',
    method: 'get',
    params: data,
  })
}

// 新增店铺续费申请记录
export function addRenewRecord(data) {
  return request({
    url: '/shop/renew/record/add',
    method: 'post',
    data: data,
  })
}

// 修改店铺续费申请记录
export function updateRenewRecord(data) {
  return request({
    url: '/shop/renew/record/edit',
    method: 'post',
    data: data,
  })
}

// 删除店铺续费申请记录
export function delRenewRecord(data) {
  return request({
    url: '/shop/renew/record/delete',
    method: 'post',
    data: data,
  })
}
